import { render } from "./FeedbackPopup.vue?vue&type=template&id=907eb5d8"
import script from "./FeedbackPopup.vue?vue&type=script&lang=js"
export * from "./FeedbackPopup.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/nexgen/apps/nxglabs-web/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__